import React, { useState } from "react";
import { Popover, IconButton, Grid, Button, Tooltip } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";

const ExportGridPopver = ({ handleDowloadTemplate=undefined ,customTooltip=undefined,customOptions=undefined,customDownload=undefined}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const hasEAPGAcces = useSelector<RootState>(
        (state) => state?.clients?.hasEAPGAccess
    );

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const handleDownload = (isVisibleColumns,hasEAPGAcces) => {
        handleDowloadTemplate(isVisibleColumns,hasEAPGAcces);
        handleClose();
    };

    return (
        <Grid item>
            <Tooltip title={customTooltip || "Export Visible/All Columns"}>
                <IconButton
                    size="small"
                    aria-describedby={id}
                    onClick={handleClick}
                >
                    <GetAppIcon />
                </IconButton>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Grid item sx={{ p: "5px 5px 0 5px" }}>
                    <Button
                        onClick={() => customDownload ? customDownload(true,handleClose): handleDownload(false,hasEAPGAcces)}
                        sx={{ color: "black" }}
                    >
                    {customOptions ? customOptions?.option1:"Export All Columns"}
                    </Button>
                </Grid>

                <Grid item sx={{ p: "5px 5px 0 5px" }}>
                    <Button
                        onClick={() => customDownload ? customDownload(false,handleClose):handleDownload(true,hasEAPGAcces)}
                        sx={{ color: "black" }}
                    >
                    {customOptions ? customOptions?.option2:"Export Visible Columns"}
                    </Button>
                </Grid>
            </Popover>
        </Grid>
    );
};

export default ExportGridPopver;
